import AddToCart from '../../components/addToCart/addToCart';
import VisualNavigationView from '../catalog/visualNavigationView';
import { register } from '../../core/bootstrapper';

register('category-new search-new', () => {
    var $visualNavigation = $('#visual-navigation');

    if ($visualNavigation.length > 0) {
        new VisualNavigationView({
            el: $visualNavigation
        });
    }

    new AddToCart({
        pageType: 'pdp_qv'
    });
});




/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/catalog/catalogNewBootstrap.js
 **/